var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-2 bg-white border rounded" }, [
    _c("div", { staticClass: "alert alert-warning pt-4 mb-0" }, [
      _c("p", [
        _c("strong", { staticClass: "gap-10px d-flex" }, [
          _vm._v(
            " \n                " + _vm._s(_vm._f("trans")("Task Cancelled"))
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }